import {isMultipleChoiceUserInputAction} from "../../../types";
import {getCurrentAction} from "../selectors";
import {PlayerReduxDispatch, PlayerReduxState} from "../types";
import chooseMultipleOptions from "./chooseMultipleOptions";
import skipAction from "./skipAction";

export default function goNext() {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    const state = getState();

    const action = getCurrentAction(state);

    if (!action) {
      console.warn("goNext: wrong player state");
      return;
    }

    if (isMultipleChoiceUserInputAction(action) && state.chosenBranches.size !== 0) {
      dispatch(chooseMultipleOptions());
    } else {
      dispatch(skipAction());
    }
  };
}
